import React from 'react';
import PropTypes from 'prop-types';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminFTPQueueFilterStatuses = ({
  counts,
  fileStatuses,
  selectedFileStatuses,
  loading,
  handleChangeFilter,
}) => {
  const intl = useIntl();

  if (Object.keys(fileStatuses).length === 0) {
    return null;
  }

  return (
    <UncontrolledDropdown className="filter-statuses">
      <DropdownToggle caret>
        {intl.formatMessage({ defaultMessage: 'Status' })}
      </DropdownToggle>
      <DropdownMenu right={true}>
        <DropdownItem
          key="status-all"
          disabled={loading}
          onClick={() => {
            handleChangeFilter({
              target: {
                name: 'selectedFileStatuses',
                value: 'all',
                checked: !selectedFileStatuses.length,
                type: 'checkbox',
              },
            });
          }}
        >
          {selectedFileStatuses.find(i => (i === 'all')) && (
            <i className="far fa-check" />
          )}
          {intl.formatMessage({ defaultMessage: 'All ({count})' }, { count: counts.all || 0 })}
        </DropdownItem>
        {Object.keys(fileStatuses).map(statusId => (
          <DropdownItem
            key={`status_${statusId}`}
            disabled={loading}
            onClick={() => {
              handleChangeFilter({
                target: {
                  name: 'selectedFileStatuses',
                  value: statusId,
                  checked: !selectedFileStatuses.includes(statusId),
                  type: 'checkbox',
                },
              });
            }}
          >
            {selectedFileStatuses.includes(statusId) && (
              <i className="far fa-check" />
            )}
            {fileStatuses[statusId]} ({counts[statusId] || 0})
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

AdminFTPQueueFilterStatuses.propTypes = {
  counts: PropTypes.object.isRequired,
  fileStatuses: PropTypes.object.isRequired,
  selectedFileStatuses: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  handleChangeFilter: PropTypes.func.isRequired,
};

export default AdminFTPQueueFilterStatuses;
